import { ModalTypes, useTicketFlowModals } from '../context';
import { AttendModal } from './AttendModal';
import { CallNextModal } from './CallNextModal';

const TicketFlowModals = () => {
  const { flowType } = useTicketFlowModals();

  const { CALL_NEXT, ATTEND } = ModalTypes;

  return (
    <>
      {flowType === CALL_NEXT && <CallNextModal />}
      {flowType === ATTEND && <AttendModal />}
    </>
  );
};

export default TicketFlowModals;
